import { SpeechSpeeds, SpeechVoices } from "./constants";
import {
  readOutLoud,
  synthesizeSpeech,
  synthesizeLongSpeech,
  registerRequestInterceptor,
} from "./methods";

/**
 * Exposes all publicly available methods from the gPolly namespace under a
 * single module.
 */
export type gPolly = {
  synthesizeSpeech: typeof synthesizeSpeech;
  synthesizeLongSpeech: typeof synthesizeLongSpeech;
  readOutLoud: typeof readOutLoud;
  registerRequestInterceptor: typeof registerRequestInterceptor;
  Voices: typeof SpeechVoices;
  Speeds: typeof SpeechSpeeds;
};

declare const window: Window & {
  gPolly?: gPolly;
};

declare const gPolly: gPolly;

window.gPolly = {
  readOutLoud,
  synthesizeSpeech,
  synthesizeLongSpeech,
  registerRequestInterceptor,
  Voices: SpeechVoices,
  Speeds: SpeechSpeeds,
};
